import {combineReducers} from "redux"
import {labelSetReducer} from "@modules/label/reducers"
import {gameReducer} from "@modules/game/reducers"
import {userReducer} from "@modules/user/reducers"
import {groupReducer} from "@modules/group/reducers"

const appReducer = combineReducers({
    labelSetReducer,
    gameReducer,
    userReducer,
    groupReducer
})

export default appReducer
